const mockDestination = [
  {
    'id': '871888aa-5dbf-4601-b7dc-14eebf151f6c',
    'description': 'Monaco - with a beautiful old town',
    'name': 'Monaco',
    'pictures': [
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/8.jpg',
        'description': 'Amsterdam famous for its crowded street markets with the best street food in Asia'
      }
    ]
  },
  {
    'id': '2ce7b3bb-ee15-4f13-95f0-550b57a9426f',
    'description': 'Amsterdam - with a beautiful old town, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque dolor massa, malesuada eget elit vitae, sollicitudin rutrum nisi. Praesent ut gravida purus, nec commodo odio. Interdum et malesuada fames ac ante ipsum primis in faucibus.',
    'name': 'Amsterdam',
    'pictures': [
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/8.jpg',
        'description': 'Amsterdam famous for its crowded street markets with the best street food in Asia'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/9.jpg',
        'description': 'Amsterdam a true asian pearl'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/6.jpg',
        'description': 'Amsterdam with an embankment of a mighty river as a centre of attraction'
      }
    ]
  },
  {
    'id': 'a2b1a841-f72b-4e13-a3a7-dc9686835641',
    'description': 'Vien - is a beautiful city',
    'name': 'Vien',
    'pictures': [
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/8.jpg',
        'description': 'Vien with a beautiful old town'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/16.jpg',
        'description': 'Vien full of of cozy canteens where you can try the best coffee in the Middle East'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/7.jpg',
        'description': 'Vien for those who value comfort and coziness'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/19.jpg',
        'description': 'Vien famous for its crowded street markets with the best street food in Asia'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/5.jpg',
        'description': 'Vien is a beautiful city'
      }
    ]
  },
  {
    'id': 'ba5f43a3-d91d-45dc-b83f-a28fa3faebec',
    'description': 'Venice - with an embankment of a mighty river as a centre of attraction',
    'name': 'Venice',
    'pictures': [
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/5.jpg',
        'description': 'Vien is a beautiful city'
      }
    ]
  },
  {
    'id': 'd7a45d4b-e2f1-46c7-b4ff-2d0aeb5dadf3',
    'description': 'Naples - a perfect place to stay with a family',
    'name': 'Naples',
    'pictures': [
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/6.jpg',
        'description': 'Naples with an embankment of a mighty river as a centre of attraction'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/3.jpg',
        'description': 'Naples with crowded streets'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/5.jpg',
        'description': 'Naples with crowded streets'
      },
      {
        'src': 'https://20.objects.htmlacademy.pro/static/destinations/17.jpg',
        'description': 'Naples with crowded streets'
      }
    ]
  }
];

export { mockDestination };
